import React, { useContext } from 'react';

import { useParams } from 'react-router-dom';

import ChannelAdminContext from '../../../../pages/portal/admin/channel/ChannelAdminContext';
import { TEMPLATE_LIBRARY_PATH } from '../../navigation/useInspectionsNavigation';
import { CustomizationCommandsProvider } from './commands/CustomizationCommandsContext';
import { useCustomizationCommands } from './application/useCustomizationCommands';
import { useTemplateCustomization } from './application/useTemplateCustomization';
import { PageState } from './components/layout/PageState';
import { TemplateCustomizationLayout } from './components/layout/TemplateCustomizationLayout';
import { ErrorBoundary } from './ErrorBoundary';
import { TemplateCustomizationProvider } from './state/TemplateCustomizationProvider';

type Props = {
  channelBasePath: string;
};

function TemplateCustomizationContent({ channelBasePath }: Props) {
  const customization = useTemplateCustomization();
  const commands = useCustomizationCommands(customization);
  const { status, viewModel, handleRetry } = customization;
  const listPageUrl = `${channelBasePath}/${TEMPLATE_LIBRARY_PATH}`;

  return (
    <CustomizationCommandsProvider commands={commands}>
      <PageState
        status={status}
        listPageUrl={listPageUrl}
        handleRetry={handleRetry}
      >
        {viewModel && (
          <TemplateCustomizationLayout
            viewModel={viewModel}
            listPageUrl={listPageUrl}
          />
        )}
      </PageState>
    </CustomizationCommandsProvider>
  );
}

export function TemplateCustomizationPage({ channelBasePath }: Props) {
  const { channel } = useContext(ChannelAdminContext);
  const { templateId } = useParams<{ templateId?: string }>();

  return (
    <ErrorBoundary>
      <TemplateCustomizationProvider
        identity={{
          channelId: channel?._id ?? '',
          templateId: templateId ?? '',
        }}
      >
        <TemplateCustomizationContent channelBasePath={channelBasePath} />
      </TemplateCustomizationProvider>
    </ErrorBoundary>
  );
}
